"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSettingsListContainerSortable = exports.TableSettingsListContainer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _TableSettingsListItem = _interopRequireDefault(require("./TableSettingsListItem"));

var _excluded = ["items", "columnOrder", "onSortEnd", "lockAxis", "helperClass", "columnSearchValue", "isSortable"];

var TableSettingsListContainer = function TableSettingsListContainer(props) {
  var items = props.items,
      columnOrder = props.columnOrder,
      onSortEnd = props.onSortEnd,
      lockAxis = props.lockAxis,
      helperClass = props.helperClass,
      columnSearchValue = props.columnSearchValue,
      isSortable = props.isSortable,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'table-settings-items-container'
  }, items.map(function (column, index) {
    return /*#__PURE__*/_react.default.createElement(_TableSettingsListItem.default, (0, _extends2.default)({
      key: column,
      index: index,
      value: column,
      orderIndex: index,
      columnOrder: columnOrder,
      columnSearchValue: columnSearchValue,
      disabled: isSortable
    }, remainingProps));
  }));
};

exports.TableSettingsListContainer = TableSettingsListContainer;
var TableSettingsListContainerSortable = (0, _reactSortableHoc.SortableContainer)(TableSettingsListContainer);
exports.TableSettingsListContainerSortable = TableSettingsListContainerSortable;